<template>
  <div v-if="initialized" class="row">
    <div v-if="company && company.status === 'PENDING'" class="card">
      <div class="card-body">
        <div class="row">
          <h5 class="text-primary text-center col-md-12" v-html="$ml.get('welcome_on_board')"></h5>
        </div>
      </div>
    </div>
    <div v-if="account.role !== 'reseller'" class="col-lg-8 col-md-7">
      <card class="card-user">
        <div slot="image" class="image">
          <img style="width: 100%;" :src="resolveImageUrl(company.bg)" @error="$event.target.src='/static/img/alideda-logo-dark.png'" alt="...">
        </div>
        <div>
          <div class="author">
            <a href="#">
              <img class="avatar border-gray" :src="resolveImageUrl(company.logo)" @error="$event.target.src='/static/img/alideda-logo-light.png'" alt="...">
              <h5 class="title">{{company.name}}</h5>
            </a>
            <p class="description">
              {{'📞 ' + company.phone + ' | 📧 ' + company.email}}
            </p>
          </div>
        </div>
        <form>
          <h5 slot="header" class="title text-center mt-5">{{$ml.get('edit_company_profile')}}</h5>
          <div class="row">
            <div class="col-md-12">
              <el-select class="select-primary mb-2" style="width: 100%" v-model="company.type"
                         :placeholder="$ml.get('company_type')">
                <el-option v-for="type in companyTypes" :key="type" class="select-primary" :value="type" :label="firstLetterUppercase(type.replace('_', ' '))"/>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        :label="$ml.get('address')"
                        :placeholder="$ml.get('address')"
                        v-model="company.address">
              </fg-input>
            </div>
            <div class="col-md-3">
              <fg-input type="text"
                        :label="$ml.get('city')"
                        :placeholder="$ml.get('city')"
                        v-model="company.city">
              </fg-input>
            </div>
            <div class="col-md-3">
              <fg-input :label="$ml.get('postal_code')"
                        :placeholder="$ml.get('postal_code')"
                        v-model="company.zip">
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input type="text"
                        :label="$ml.get('website')"
                        :placeholder="$ml.get('for_example') + ' alideda.com'"
                        v-model="company.links.website">
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input type="text"
                        :label="'Facebook username'"
                        :placeholder="$ml.get('for_example') + ': alideda'"
                        v-model="company.links.facebook">
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input label="Instagram username"
                        :placeholder="$ml.get('for_example') + ': alideda'"
                        v-model="company.links.instagram">
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        label="Latitude"
                        placeholder="Latitude"
                        v-model="company.latitude">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="text"
                        label="Longitude"
                        placeholder="Longitude"
                        v-model="company.longitude">
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <fg-input :label="$ml.get('short_description')">
                <textarea class="form-control"
                          :placeholder="$ml.get('short_description')"
                          v-model="company.short_desc">
                </textarea>
                <div v-if="emojiData" class="message-emoji">
                  <emoji-picker @emoji:picked="(emoji) => company.short_desc += emoji" :data="emojiData" />
                </div>
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <fg-input :label="$ml.get('about_company')">
                <textarea class="form-control"
                          :placeholder="$ml.get('about_company_placeholder')"
                          v-model="company.long_desc">
                </textarea>
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <el-select style="width: 100%" class="select-primary" :placeholder="$ml.get('select_language')"
                         v-model="company.LanguageId">
                <el-option v-for="lang in languages" class="select-primary" :value="lang.id" :label="lang.name"
                           :key="lang.id">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6">
              <el-select style="width: 100%" class="select-primary" :placeholder="$ml.get('select_country')"
                         v-model="company.CountryId">
                <el-option v-for="country in countries" class="select-primary" :value="country.id" :label="country.name"
                           :key="country.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <n-button @click.native="updateProfile" href="#" type="primary" round=""
                        style="background-color:#1A385C; right: 20px; width: 100%;">
                {{$ml.get('update_profile')}}
              </n-button>
            </div>
          </div>
        </form>
      </card>
    </div>

    <!-- Profile -->
    <div style="margin: 0 auto;" class="col-lg-4 col-md-5">
      <card class="card-user">
        <div>
          <div class="author">
            <img class="avatar border-gray" :src="account.photo" alt="...">
            <h5 class="title">{{account.username}}</h5>
            <p class="description"></p>
          </div>
        </div>
        <form action="javascript:;" class="mt-5">
          <div class="row">
            <div class="col-md-12">
              <fg-input type="password"
                        :label="$ml.get('current_password')"
                        :placeholder="$ml.get('current_password')"
                        v-model="currentPassword">
              </fg-input>
            </div>
            <div class="col-md-12">
              <fg-input type="password"
                        :label="$ml.get('new_password')"
                        :placeholder="$ml.get('new_password')"
                        v-model="newPassword">
              </fg-input>
            </div>
            <div class="col-md-12">
              <fg-input type="password"
                        :label="$ml.get('repeat_password')"
                        :placeholder="$ml.get('repeat_password')"
                        v-model="newPasswordRepeat">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <n-button @click.native="changePassword" type="primary" round>
                {{$ml.get('change_password')}}
              </n-button>
            </div>
          </div>
        </form>
      </card>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import Account from '../../services/Account'
  import Company from '../../services/Company'
  import {Select, Option} from 'element-ui'
  import to from 'await-to-js'
  import emojiData from '@zaichaopan/emoji-picker/data/emojis.json';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    data() {
      return {
        emojiData,
        currentPassword: '',
        newPassword: '',
        newPasswordRepeat: ''
      }
    },
    computed: {
      ...mapGetters(['companyTypes'])
    },
    mounted() {},
    methods: {
      async changePassword() {
        // Validate form
        if (this.currentPassword.length < 8 || this.newPassword.length < 8) {
          return this.errorSnack({ message: this.$ml.get('password_too_short') });
        }
        if (this.newPassword !== this.newPasswordRepeat) {
          return this.errorSnack({ message: this.$ml.get('password_not_same') });
        }

        this.prompt(async () => {
            let [err, response] = await to(Account.changePassword({
              currentPassword: this.currentPassword,
              password: this.newPassword,
              passwordRepeat: this.newPasswordRepeat
            }));
            if (err) return this.errorSnack(err);
            if (response.data.success) {
              this.successSnack(this.$ml.get('success_reset'));
              return this.$store.dispatch('logout');
            }
        });
      },
      async updateProfile() {
        let data = this.company;
        this.prompt(async () => {
          data.tokens = undefined;
          data.status = undefined;
          let [err, response] = await to(Company.update(data));
          if (err) return this.errorSnack(err);
          if (response.data.success) this.successSnack(this.$ml.get('saved'))
        });
      }
    }
  }

</script>
<style scoped>

</style>
